/*
 * Public API Surface of ngx-onesignal
 */

export * from './lib/service/one-signal.service';
export * from './lib/one-signal.module';
export * from './lib/interface';
